import { render, staticRenderFns } from "./ExpenseList.vue?vue&type=template&id=2ce9f8f0&scoped=true&"
import script from "./ExpenseList.vue?vue&type=script&lang=js&"
export * from "./ExpenseList.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseList.vue?vue&type=style&index=0&id=2ce9f8f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce9f8f0",
  null
  
)

export default component.exports